/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AccountData,
    AccountDataFromJSON,
    AccountDataToJSON,
} from '../models/AccountData';
import {
    type AccountDataUpdateLog,
    AccountDataUpdateLogFromJSON,
    AccountDataUpdateLogToJSON,
} from '../models/AccountDataUpdateLog';
import {
    type AccountQuery,
    AccountQueryFromJSON,
    AccountQueryToJSON,
} from '../models/AccountQuery';
import {
    type ModificationRequest,
    ModificationRequestFromJSON,
    ModificationRequestToJSON,
} from '../models/ModificationRequest';
import {
    type ModificationResponse,
    ModificationResponseFromJSON,
    ModificationResponseToJSON,
} from '../models/ModificationResponse';

export interface CreateAccountsRequest {
    id: string;
    accountData: Array<AccountData>;
}

export interface DeleteAccountsRequest {
    id: string;
    requestBody: Array<string>;
}

export interface DeleteAllAccountsRequest {
    id: string;
}

export interface GetAccountUpdatesBySegmentRequest {
    id: string;
    from?: Date;
}

export interface GetAccountsByQueryRequest {
    id: string;
    accountQuery: AccountQuery;
}

export interface GetAccountsBySegmentRequest {
    id: string;
}

export interface ModifyAccountsRequest {
    id: string;
    modificationRequest: ModificationRequest;
}

export interface UpdateAccountsRequest {
    id: string;
    accountData: Array<AccountData>;
}

/**
 * 
 */
export class SegmentAccountApi extends runtime.BaseAPI {

    /**
     * Creates request options for createAccounts without sending the request
     */
    async createAccountsRequestOpts(requestParameters: CreateAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createAccounts().'
            );
        }

        if (requestParameters['accountData'] == null) {
            throw new runtime.RequiredError(
                'accountData',
                'Required parameter "accountData" was null or undefined when calling createAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/account`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['accountData']!.map(AccountDataToJSON),
        };
    }

    /**
     */
    async createAccountsRaw(requestParameters: CreateAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountData>>> {
        const requestOptions = await this.createAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountDataFromJSON));
    }

    /**
     */
    async createAccounts(requestParameters: CreateAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountData>> {
        const response = await this.createAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAccounts without sending the request
     */
    async deleteAccountsRequestOpts(requestParameters: DeleteAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAccounts().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling deleteAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/account/delete`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async deleteAccountsRaw(requestParameters: DeleteAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccounts(requestParameters: DeleteAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteAllAccounts without sending the request
     */
    async deleteAllAccountsRequestOpts(requestParameters: DeleteAllAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAllAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/account/delete`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteAllAccountsRaw(requestParameters: DeleteAllAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAllAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAllAccounts(requestParameters: DeleteAllAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAllAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAccountUpdatesBySegment without sending the request
     */
    async getAccountUpdatesBySegmentRequestOpts(requestParameters: GetAccountUpdatesBySegmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAccountUpdatesBySegment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/account/changes`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAccountUpdatesBySegmentRaw(requestParameters: GetAccountUpdatesBySegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountDataUpdateLog>>> {
        const requestOptions = await this.getAccountUpdatesBySegmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountDataUpdateLogFromJSON));
    }

    /**
     */
    async getAccountUpdatesBySegment(requestParameters: GetAccountUpdatesBySegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountDataUpdateLog>> {
        const response = await this.getAccountUpdatesBySegmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccountsByQuery without sending the request
     */
    async getAccountsByQueryRequestOpts(requestParameters: GetAccountsByQueryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAccountsByQuery().'
            );
        }

        if (requestParameters['accountQuery'] == null) {
            throw new runtime.RequiredError(
                'accountQuery',
                'Required parameter "accountQuery" was null or undefined when calling getAccountsByQuery().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/account/query`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccountQueryToJSON(requestParameters['accountQuery']),
        };
    }

    /**
     */
    async getAccountsByQueryRaw(requestParameters: GetAccountsByQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountData>>> {
        const requestOptions = await this.getAccountsByQueryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountDataFromJSON));
    }

    /**
     */
    async getAccountsByQuery(requestParameters: GetAccountsByQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountData>> {
        const response = await this.getAccountsByQueryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccountsBySegment without sending the request
     */
    async getAccountsBySegmentRequestOpts(requestParameters: GetAccountsBySegmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAccountsBySegment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/account`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAccountsBySegmentRaw(requestParameters: GetAccountsBySegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountData>>> {
        const requestOptions = await this.getAccountsBySegmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountDataFromJSON));
    }

    /**
     */
    async getAccountsBySegment(requestParameters: GetAccountsBySegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountData>> {
        const response = await this.getAccountsBySegmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for modifyAccounts without sending the request
     */
    async modifyAccountsRequestOpts(requestParameters: ModifyAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling modifyAccounts().'
            );
        }

        if (requestParameters['modificationRequest'] == null) {
            throw new runtime.RequiredError(
                'modificationRequest',
                'Required parameter "modificationRequest" was null or undefined when calling modifyAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/account/modify`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ModificationRequestToJSON(requestParameters['modificationRequest']),
        };
    }

    /**
     */
    async modifyAccountsRaw(requestParameters: ModifyAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ModificationResponse>> {
        const requestOptions = await this.modifyAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ModificationResponseFromJSON(jsonValue));
    }

    /**
     */
    async modifyAccounts(requestParameters: ModifyAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ModificationResponse> {
        const response = await this.modifyAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateAccounts without sending the request
     */
    async updateAccountsRequestOpts(requestParameters: UpdateAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAccounts().'
            );
        }

        if (requestParameters['accountData'] == null) {
            throw new runtime.RequiredError(
                'accountData',
                'Required parameter "accountData" was null or undefined when calling updateAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/account`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['accountData']!.map(AccountDataToJSON),
        };
    }

    /**
     */
    async updateAccountsRaw(requestParameters: UpdateAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountData>>> {
        const requestOptions = await this.updateAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountDataFromJSON));
    }

    /**
     */
    async updateAccounts(requestParameters: UpdateAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountData>> {
        const response = await this.updateAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
